import styled from "styled-components";
import { typographyMixin } from "../../typography";
import { setThemeColor } from "../../setThemeColor";
import { AlertProps } from "./Alert.types";
import { textColorMixin, backgroundColorMutedMixin } from "../../colors";

type StyledAlertProps = Pick<AlertProps, "theme" | "variant">;

export const StyledAlert = styled.div<StyledAlertProps>`
  ${typographyMixin}

  ${textColorMixin}

  ${backgroundColorMutedMixin}
  
  padding: 1.075rem 1.35rem;
  border-radius: 0.2rem;
  margin: 0.2rem;
  font-size: 0.9rem;

  .title-bar1 {
    margin: -1.075rem -1.35rem;
    margin-bottom: 1.075rem;
  }

  .message {
    filter: brightness(0.6);
  }
`;

export const StyledWarningAlert = styled.div`
  width: 15rem;
  max-width: 20rem;
  text-align: center;
  margin: 4rem auto;
  display: block;

  h1 {
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: Rubik, Arial, sans-serif;
    font-size: 2.1875rem;
    line-height: 1.2;
    font-weight: 300;
    white-space: nowrap;
    padding: 3rem 0;
    @media only screen and (max-width: 600px) {
      white-space: pre-wrap;
    }
  }
`;
